// @ts-nocheck
import { BrandStateContext } from "@insite/client-framework/Store/Data/Brands/BrandsSelectors";
import { BrandModel } from "@insite/client-framework/Types/ApiModels";
import { useContext } from "react";

const useHasLogoOrWebsite = (brand?: BrandModel): boolean => {
    const { logoLargeImagePath, logoSmallImagePath, externalUrl } = brand || useContext(BrandStateContext).value || {};

    return Boolean(logoLargeImagePath?.length || logoSmallImagePath?.length || externalUrl?.length);
};

export default useHasLogoOrWebsite;
